module.exports = __webpack_public_path__ + "img/btn-spare.a93fd097.png";